import React from "react";
import "./ServerCard.css";

export default function ServerCard({ servidor }) {
  const isOnline = servidor.status === "online";

  return (
    <article
      className={`scmd-card ${isOnline ? "is-online" : "is-offline"}`}
      data-highlight={isOnline ? "ok" : "danger"}
    >
      <header className="scmd-card__header">
        <h3 className="scmd-card__title">{servidor.nome}</h3>
        <div className="scmd-card__status">
          <span className={`scmd-badge ${isOnline ? "ok" : "danger"}`}>
            {isOnline ? "Online" : "Offline"}
          </span>
          <span className={`scmd-dot ${isOnline ? "ok" : "danger"}`} />
        </div>
      </header>

      <ul className="scmd-card__list">
        <li className="scmd-kv">
          <b>Domínio:</b>
          <span>{servidor.app_url || "—"}</span>
        </li>
        <li className="scmd-kv">
          <b>Servidor:</b>
          <span>{servidor.server_url || "—"}</span>
        </li>

        {servidor.responseTime != null && (
          <li className="scmd-kv">
            <b>Tempo de resposta:</b>
            <span>{servidor.responseTime}ms</span>
          </li>
        )}

        {servidor.error && (
          <li className="scmd-kv">
            <b>Erro:</b>
            <span className="scmd-error">{servidor.error}</span>
          </li>
        )}

        <li className="scmd-kv">
          <b>Verificado em:</b>
          <span>
            {servidor.lastCheck
              ? new Date(servidor.lastCheck).toLocaleString()
              : "—"}
          </span>
        </li>
      </ul>
    </article>
  );
}
